import { Loader2 } from 'lucide-react';

/**
 * Centered loading spinner with optional message.
 * Replaces the repeated "Вчитување..." divs.
 */
export default function LoadingState({ message = 'Вчитување...', className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-2 p-8 text-gray-500 ${className}`}>
      <Loader2 className="w-5 h-5 animate-spin" />
      <span>{message}</span>
    </div>
  );
}
